import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
    Button,
    Card,
    Col,
    Container,
    Input,
    Label,
    Row,
    Spinner,
} from "reactstrap";
import {
    downLoadMomento,
    getAllBoughtMomentos,
    getFanData,
} from "../../store/actions/FanActions";

import moment from "moment";

const BoughtMomentos = () => {
    const dispatch = useDispatch();
    const { uid } = useSelector((state) => state.authUser);
    const { fanBoughtGallery, fanLoading, momentoLoading } = useSelector(
        (state) => state.fanReducer
    );
    let {user} = useSelector((state) => state.authUser);
console.log(user)
    const [momentosGallery, setMomentosGallery] = useState([]);
    const [allowDetailsIndex, setAllowDetailsIndex] = useState(-1);
    const [downLoadIndex, setdownLoadIndex] = useState(-1);
    const [searchByName, setSearchByName] = useState("");
    const [searchByID, setSearchByID] = useState("");
    useEffect(() => {
        dispatch(getAllBoughtMomentos(uid));
    }, []);
    useEffect(() => {
        if (fanBoughtGallery?.length > 0) {
            setMomentosGallery(fanBoughtGallery);
        }
    }, [fanBoughtGallery]);

    useEffect(() => {
        if (searchByName) {
            const filteredMomentos = fanBoughtGallery.filter((momento) => {
                return momento.athleteName
                    .toLowerCase()
                    .includes(searchByName.toLowerCase());
            });
            setMomentosGallery(filteredMomentos);
        } else if (searchByID) {
            const filteredMomentos = fanBoughtGallery.filter((momento) => {
                return momento?.athleteID?.toString()?.includes(searchByID);
            });
            setMomentosGallery(filteredMomentos);
        } else {
            setMomentosGallery(fanBoughtGallery);
        }
    }, [searchByName, searchByID]);

    const formatDate = (date) => {
        const unixTimestamp = date.seconds + date.nanoseconds / 1e9;
        const jsDate = new Date(unixTimestamp * 1000);

        const formattedDate = moment(jsDate).format("DD/MM/YYYY HH:mm");
        return formattedDate;
    };

    return (
        <Container fluid>
            <Row className="justify-content-center mx-4 py-3">
                <h3>My Bought Mementos</h3>
            </Row>
            {momentoLoading ? (
                <Row className="justify-content-center">
                    <Spinner size="sm" />
                </Row>
            ) : (
                <>
                    <Row className="justify-content-center justify-content-lg-between mx-5 py-3">
                        <Col lg={4} sm={10} className="mb-3 mb-lg-0">
                            <Input
                                placeholder="Search By Athlete Name"
                                value={searchByName}
                                onChange={(e) =>
                                    setSearchByName(e.target.value)
                                }
                            />
                        </Col>
                        <Col lg={4} sm={10}>
                            <Input
                                placeholder="Search By Athlete ID"
                                value={searchByID}
                                onChange={(e) => setSearchByID(e.target.value)}
                            />
                        </Col>
                    </Row>
                    <Container>
                        {momentosGallery?.length > 0 ? (
                            <>
                                {momentosGallery?.map((item, index) => {
                                    return (
                                        <>
                                            <Card
                                                className={`mb-5  p-4 create_momento-card ${
                                                    index == 0 ? "mt-5" : ""
                                                }`}
                                                key={item.id}
                                            >
                                                <Row className="d-flex justify-content-center">
                                                    <Col lg={4} md={4} sm={10}>
                                                        <div>
                                                            <Label>
                                                                Memento Title
                                                            </Label>
                                                            <p>
                                                                <strong>
                                                                    {
                                                                        item?.momentoTitle
                                                                    }
                                                                </strong>
                                                            </p>
                                                        </div>
                                                        <div>
                                                            <Label>
                                                                Memento
                                                                Description
                                                            </Label>
                                                            <p>
                                                                <strong>
                                                                    {
                                                                        item?.momentoDescription
                                                                    }
                                                                </strong>
                                                            </p>
                                                        </div>
                                                    </Col>
                                                    <Col lg={4} md={4} sm={10}>
                                                        <div>
                                                            <Label>
                                                                Athlete
                                                            </Label>
                                                            <p>
                                                                <strong>
                                                                    {
                                                                        item?.athleteName
                                                                    }
                                                                </strong>
                                                            </p>
                                                        </div>
                                                        <div>
                                                            <Label>
                                                                Created
                                                            </Label>
                                                            <p>
                                                                <strong>
                                                                    {item?.createdAt &&
                                                                        formatDate(
                                                                            item?.createdAt
                                                                        )}
                                                                </strong>
                                                            </p>
                                                        </div>
                                                    </Col>
                                                    <Col lg={4} md={4} sm={10}>
                                                        <div>
                                                            <Label>
                                                                Memento ID
                                                            </Label>
                                                            <p>
                                                                <strong>
                                                                    {
                                                                        item?.momentoID
                                                                    }
                                                                </strong>
                                                            </p>
                                                        </div>
                                                        <div>
                                                            <Label>
                                                                Athlete ID
                                                            </Label>
                                                            <p>
                                                                <strong>
                                                                    {
                                                                        item?.athleteID
                                                                    }
                                                                </strong>
                                                            </p>
                                                        </div>
                                                    </Col>
                                                </Row>
                                                {allowDetailsIndex == index && (
                                                    <Container className="d-flex flex-column momento__media">
                                                        <Row className="p-3 flex-nowrap">
                                                            <Col className="col-1 d-flex flex-column justify-content-around pt-5 mr-1 pl-0 momento__media-qrCode_col">
                                                                {item.qrCodes?.map(
                                                                    (
                                                                        qrCode,
                                                                        qrIdx
                                                                    ) => {
                                                                        if (
                                                                            qrIdx ==
                                                                                0 ||
                                                                            qrIdx ==
                                                                                1
                                                                        ) {
                                                                            return (
                                                                                <>
                                                                                    {qrCode !==
                                                                                    "" ? (
                                                                                        <div className="position-relative">
                                                                                            <img
                                                                                                src={
                                                                                                    qrCode instanceof
                                                                                                    File
                                                                                                        ? URL.createObjectURL(
                                                                                                              qrCode
                                                                                                          )
                                                                                                        : qrCode
                                                                                                }
                                                                                                className="w-100 create_momento-QR_img"
                                                                                                alt={`QR Code ${qrIdx}`}
                                                                                            />
                                                                                        </div>
                                                                                    ) : (
                                                                                        <div className="create_momento-qrcode_div d-flex justify-content-center align-items-center border-0"></div>
                                                                                    )}
                                                                                </>
                                                                            );
                                                                        }
                                                                    }
                                                                )}
                                                            </Col>

                                                            {item?.momento?.map(
                                                                (
                                                                    momentoItem
                                                                ) => {
                                                                    return (
                                                                        <Col className="p-2 momento__media-card">
                                                                            <Card className="w-100 p-3 create_momento-card d-flex flex-column justify-content-start align-items-center">
                                                                                <p className="mt-3 text-capitalize">
                                                                                    <strong>
                                                                                        {
                                                                                            momentoItem.title
                                                                                        }
                                                                                    </strong>
                                                                                </p>
                                                                                <p className="mt-3 text-capitalize">
                                                                                    {
                                                                                        momentoItem.subTitle
                                                                                    }
                                                                                </p>

                                                                                <div className="create_momento__media-div">
                                                                                    {momentoItem?.media ? (
                                                                                        <img
                                                                                            src={
                                                                                                momentoItem.media
                                                                                            }
                                                                                            alt="img"
                                                                                            className="w-100 create_momento__media-div_img"
                                                                                        />
                                                                                    ) : (
                                                                                        <>
                                                                                            No
                                                                                            Media
                                                                                            Attached
                                                                                        </>
                                                                                    )}
                                                                                </div>
                                                                            </Card>
                                                                        </Col>
                                                                    );
                                                                }
                                                            )}
                                                            <Col className="col-1 d-flex flex-column-reverse justify-content-around pt-5 mr-1 pr-0 momento__media-qrCode_col">
                                                                {item.qrCodes?.map(
                                                                    (
                                                                        qrCode,
                                                                        qrIdx
                                                                    ) => {
                                                                        if (
                                                                            qrIdx ===
                                                                                item
                                                                                    .qrCodes
                                                                                    .length -
                                                                                    2 ||
                                                                            qrIdx ===
                                                                                item
                                                                                    .qrCodes
                                                                                    .length -
                                                                                    1
                                                                        ) {
                                                                            return (
                                                                                <>
                                                                                    {qrCode !==
                                                                                    "" ? (
                                                                                        <div className="position-relative">
                                                                                            <img
                                                                                                src={
                                                                                                    qrCode instanceof
                                                                                                    File
                                                                                                        ? URL.createObjectURL(
                                                                                                              qrCode
                                                                                                          )
                                                                                                        : qrCode
                                                                                                }
                                                                                                className="w-100 create_momento-QR_img"
                                                                                                alt={`QR Code ${qrIdx}`}
                                                                                            />
                                                                                        </div>
                                                                                    ) : (
                                                                                        <div className="create_momento-qrcode_div d-flex justify-content-center align-items-center border-0"></div>
                                                                                    )}
                                                                                </>
                                                                            );
                                                                        }
                                                                    }
                                                                )}
                                                            </Col>
                                                        </Row>
                                                        <Row className="d-flex justify-content-between align-items-center mx-0 px-0 my-3 flex-nowrap">
                                                            {item.qrCodes?.map(
                                                                (
                                                                    qrCode,
                                                                    qrIdx
                                                                ) => {
                                                                    if (
                                                                        qrIdx >=
                                                                            2 &&
                                                                        qrIdx <
                                                                            item
                                                                                .qrCodes
                                                                                .length -
                                                                                2
                                                                    ) {
                                                                        return (
                                                                            <div className="momento__media-qrCode_row">
                                                                                {qrCode !==
                                                                                "" ? (
                                                                                    <div className="position-relative">
                                                                                        <img
                                                                                            src={
                                                                                                qrCode instanceof
                                                                                                File
                                                                                                    ? URL.createObjectURL(
                                                                                                          qrCode
                                                                                                      )
                                                                                                    : qrCode
                                                                                            }
                                                                                            className="w-100 create_momento-QR_img"
                                                                                            alt={`QR Code ${qrIdx}`}
                                                                                        />
                                                                                    </div>
                                                                                ) : (
                                                                                    <div className="create_momento-qrcode_div d-flex justify-content-center align-items-center border-0"></div>
                                                                                )}
                                                                            </div>
                                                                        );
                                                                    }
                                                                }
                                                            )}
                                                        </Row>
                                                    </Container>
                                                )}

                                                <Row className="pr-4 my-3 justify-content-center justify-content-md-end">
                                                    <Button
                                                        size="sm"
                                                        color="primary"
                                                        onClick={() => {
                                                            if (
                                                                allowDetailsIndex ==
                                                                index
                                                            ) {
                                                                setAllowDetailsIndex(
                                                                    -1
                                                                );
                                                            } else {
                                                                setAllowDetailsIndex(
                                                                    index
                                                                );
                                                            }
                                                        }}
                                                    >
                                                        {allowDetailsIndex ==
                                                        index
                                                            ? "Hide Details"
                                                            : "View Details"}
                                                    </Button>
                                                    <Button
                                                        size="sm"
                                                        color="primary"
                                                        className="mx-3"
                                                        onClick={() => {
                                                            setdownLoadIndex(
                                                                index
                                                            );
                                                            dispatch(
                                                                downLoadMomento(
                                                                    item, user.name,
                                                                    () => {
                                                                        setdownLoadIndex(
                                                                            -1
                                                                        );
                                                                    }
                                                                )
                                                            );
                                                        }}
                                                        disabled={fanLoading}
                                                    >
                                                        {fanLoading &&
                                                        downLoadIndex ==
                                                            index ? (
                                                            <Spinner
                                                                size="sm"
                                                                className="mx-4"
                                                            />
                                                        ) : (
                                                            "Download"
                                                        )}
                                                    </Button>
                                                </Row>
                                            </Card>
                                        </>
                                    );
                                })}
                            </>
                        ) : (
                            <>
                                <Row className="d-flex justify-content-center">
                                    <p>No Mementos Found</p>
                                </Row>
                            </>
                        )}
                    </Container>{" "}
                </>
            )}
        </Container>
    );
};

export default BoughtMomentos;
